import { initializeApp } from 'firebase/app';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics, setAnalyticsCollectionEnabled } from 'firebase/analytics';
import { getStorage } from 'firebase/storage';

// Configuración de Firebase
const firebaseConfig = {
    apiKey: "AIzaSyDJVyht6EFTOkaZombgKrGDlYhf0PfXJDE",
    authDomain: "hostal-185a2.firebaseapp.com",
    projectId: "hostal-185a2",
    storageBucket: "hostal-185a2.firebasestorage.app",
    messagingSenderId: "184705524000",
    appId: "1:184705524000:web:816f2a53f42b1e7f8a3745",
    measurementId: "G-DYVSSW5PM6"
};

// Inicializar Firebase
let app;
let firestore;
let auth;
let analytics;
let storage;

try {
    app = initializeApp(firebaseConfig);
    firestore = getFirestore(app);
    auth = getAuth(app);
    analytics = getAnalytics(app);
    storage = getStorage(app);
    
    // Deshabilitar Analytics en el área de administrador
    const isAdminArea = window.location.pathname.startsWith('/admin') || 
                       window.location.hostname.startsWith('admin.');
    
    setAnalyticsCollectionEnabled(analytics, !isAdminArea);
    
    // Habilitar persistencia cuando sea posible (fallará en pestañas múltiples en algunos navegadores)
    enableIndexedDbPersistence(firestore)
        .then(() => {
            console.log("Firebase: Persistencia offline habilitada.");
        })
        .catch((err) => {
            console.warn("Firebase: Error al habilitar persistencia offline", err);
            if (err.code === 'failed-precondition') {
                console.warn("La persistencia falló debido a múltiples pestañas abiertas.");
            } else if (err.code === 'unimplemented') {
                console.warn("El navegador actual no soporta persistencia offline.");
            }
        });
        
    console.log("Firebase inicializado correctamente");
} catch (error) {
    console.error("Error al inicializar Firebase:", error);
}

// Exportar la instancia de Firestore
export const db = firestore;
// Exportar la instancia de Auth
export const firebase_auth = auth;
// Exportar la instancia de Analytics
export const firebase_analytics = analytics;
// Exportar la instancia de Storage
export const firebase_storage = storage; 